import { render, staticRenderFns } from "./DataModelTreeNode.vue?vue&type=template&id=60bdc833&"
import script from "./DataModelTreeNode.vue?vue&type=script&lang=ts&"
export * from "./DataModelTreeNode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports